<div class="bn-app-shield-waf-triggered-slideout">
  <div class="bn-app-shield-waf-triggered-slideout__header bn-fade bn-fade--top">
    <div class="scroller mb-4 mx-5 mt-2">
      <span
        class="scroller__button"
        [ngClass]="{
          'scroller__button--disabled': (rulesCount || 0) < 2,
        }"
        (click)="onDirectionClick('prev')"
        ><fa-icon icon="chevron-left"
      /></span>
      @if (selectedRuleIndex !== undefined && rulesCount) {
        <span class="text-300-regular text-bunny-dark my-2">
          <span class="text-300-semi-bold">{{ selectedRuleIndex + 1 }}</span> of {{ rulesCount }} rule</span
        >
      } @else {
        <ngx-skeleton-loader
          appearance="line"
          count="1"
          [theme]="{
            'height.px': 24,
            'margin-bottom': 0,
            'margin-top': '6px',
            'width.px': 100,
            overflow: 'hidden',
          }" />
      }
      <span
        class="scroller__button"
        [ngClass]="{
          'scroller__button--disabled': (rulesCount || 0) < 2,
        }"
        (click)="onDirectionClick('next')"
        ><fa-icon icon="chevron-right"
      /></span>
    </div>
  </div>
  <div class="bn-app-shield-waf-triggered-slideout__content">
    <div class="px-5">
      <div class="mb-4">
        <div class="text-600-regular text-bunny-dark mt-4">
          @if (internalTriggeredRule?.ruleId) {
            Rule {{ internalTriggeredRule?.ruleId }}
          } @else {
            <ngx-skeleton-loader
              appearance="line"
              count="1"
              [theme]="{
                'height.px': 24,
                'margin-bottom': 0,
                'margin-top': '6px',
                'width.px': 100,
                overflow: 'hidden',
              }" />
          }
        </div>
      </div>
      <bn-web-ui-card
        heading="Rule Description"
        [noShadow]="true">
        @if (internalTriggeredRule?.ruleDescription) {
          {{ internalTriggeredRule?.ruleDescription }}
        } @else {
          <ngx-skeleton-loader
            appearance="line"
            count="1"
            [theme]="{
              'height.px': 24,
              'margin-bottom': 0,
              'margin-top': '6px',
              'width.%': 100,
              overflow: 'hidden',
            }" />
        }
      </bn-web-ui-card>

      <div class="my-2">
        <bn-web-ui-card
          heading="Triggered Rules"
          [noShadow]="true">
          <div class="chart-container position-relative">
            <app-chart-volume-of-attacks
              [data]="chartData.chartSeries"
              [isLoading]="isChartLoading()" />
            @if (!hasChartData && !isChartLoading()) {
              <div class="chart-overlay">
                <span>There is no attack data to show yet.</span>
              </div>
            }
          </div>
        </bn-web-ui-card>
      </div>

      <div class="table-card">
        <div class="table-card__wrap">
          <div class="table-card__title">Top Targeted URLs</div>
          <table class="ps-3">
            <tbody>
              @if (topTargetedUrls) {
                @for (urlKey of topTargetedUrlKeys; track urlKey) {
                  <tr class="table-card__row">
                    <td class="text-break">
                      <bn-web-ui-badge
                        color="default"
                        contentClass="me-2"
                        size="sm"
                        type="tag"
                        >WAF</bn-web-ui-badge
                      >
                      <fa-icon
                        class="me-1"
                        icon="link-horizontal" />
                      {{ urlKey | decodeURI }}
                    </td>
                    <td class="text-end">{{ topTargetedUrls[urlKey] }}</td>
                  </tr>
                }
              }
              @if (topTargetedUrls === null) {
                @for (item of [].constructor(5); track $index) {
                  <tr>
                    <td [ngStyle]="{ width: '80%' }">
                      <ngx-skeleton-loader [theme]="{ 'width.%': 95, height: '16px', 'margin-bottom': '0' }" />
                    </td>
                    <td [ngStyle]="{ width: '20%' }">
                      <ngx-skeleton-loader [theme]="{ 'width.%': 95, height: '16px', 'margin-bottom': '0' }" />
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
        </div>
      </div>

      <div class="table-card mb-2">
        <div class="table-card__wrap mt-2">
          <div class="table-card__title">Inbound HTTP Requests</div>
          <app-app-shield-event-logs-waf
            [logs]="logs"
            [showFilter]="false" />
        </div>
      </div>
    </div>
  </div>
  <div class="bn-app-shield-waf-triggered-slideout__footer bn-fade bn-fade--bottom">
    <div class="px-5 py-3">
      <bn-web-ui-info-card
        class="mt-2 mb-4"
        customBg="var(--gradient-info-card-background)"
        heading="Shield AI Recommendation"
        image="/assets/images/bunny-shield-protection-level-extreme.svg"
        [headingBadges]="
          this.selectedShield()?.planType === planType.Basic
            ? [
                {
                  context: 'premium',
                  text: 'Advanced',
                  size: 'sm',
                },
              ]
            : []
        "
        [imageOptions]="{
          maxHeight: '95px',
          marginBottom: '20px',
          marginRight: '20px',
          disableGrow: true,
        }">
        @if (aiRecommendationText()) {
          <span>{{ aiRecommendationText() }}</span>
        } @else {
          @if ((this.selectedShield()?.planType || 0) > planType.Basic) {
            <bn-web-ui-button
              class="me-2"
              itemStyle="stroke"
              [loading]="isLoadingAIRecommendations()"
              (click)="getRecomendations(this.getSelectedShieldId(), internalTriggeredRule?.ruleId)"
              >Ask Shield AI</bn-web-ui-button
            >
          } @else {
            <div
              [ngClass]="{
                'bn-app-shield-waf-triggered-slideout__ai--blur': this.selectedShield()?.planType === planType.Basic,
              }">
              With 100% confidence we can say... Bunny Shield AI recommends that you upgrade to <strong>Advanced</strong>.
            </div>
          }
        }
      </bn-web-ui-info-card>
      <bn-web-ui-button
        class="me-2"
        [loading]="isLoading()"
        (click)="setRuleAction(internalTriggeredRule?.ruleId, reviewActionType.Ignore)"
        >Ignore Triggered Rules</bn-web-ui-button
      >
      <bn-web-ui-button
        class="me-2"
        itemStyle="stroke"
        [loading]="isLoading()"
        (click)="setRuleAction(internalTriggeredRule?.ruleId, reviewActionType.LogOnly)"
        >Log Rule</bn-web-ui-button
      >
      <bn-web-ui-button
        itemStyle="stroke"
        [loading]="isLoading()"
        (click)="setRuleAction(internalTriggeredRule?.ruleId, reviewActionType.DisableRule)"
        >Disable Rule</bn-web-ui-button
      >
    </div>
  </div>
</div>
